<template>
  <div class="buy">
    <div class="buy-top">
        <div
            class="member-cards pr"
            :style="'background:url(' + detail.bg + ')  no-repeat;color:'+detail.colorText"
        >
            <div class="cards-top flex pr">
            <img :src="detail.icon" alt="等级图标" />
            <div class="cards-top-con">
                <h3>{{detail.vipName}}</h3>
                <!-- <p class="fs12">NO. 0099 9292 7652</p> -->
            </div>
            </div>
            <!-- <div class="pa cards-bottom fs12">有效期至2021-10-31</div> -->
        </div>
    </div>
    <van-cell-group class="buy-member" :border='false'>
        <van-cell title="会员分类" :value="detail.name" />
        <van-cell title="会员金额" >
            <template #right-icon>
                <span class="members-price">￥{{totalPice}}</span>
            </template>
        </van-cell>
    </van-cell-group>
    <h4>请选择支付方式</h4>
    <van-cell-group class="buy-member" :border='false'>
        <van-cell title="会员分类" >
             <template #title>
                <img src="@/assets/imgs/members/wx.png" alt="微信">
                <span class="custom-title">微信支付</span>
            </template>
            <template #right-icon >
                <div @click="selectPay('payWx')">
                     <img v-if="payWx" src="@/assets/imgs/members/buy-checked.png" alt="选中">
                     <img v-else src="@/assets/imgs/members/uncheck.png" alt="未选中">
                </div>
            </template>
        </van-cell>
        <van-cell title="会员金额" >
            <template #title>
                <img src="@/assets/imgs/members/wallet.png" alt="微信">
                <span class="custom-title">钱包余额支付</span>
                <label>({{myWallet}}元)</label>
            </template>
            <template #right-icon >
                <div @click="selectPay('payWallet')">
                     <img v-if="payWallet" src="@/assets/imgs/members/buy-checked.png" alt="选中">
                     <img v-else src="@/assets/imgs/members/uncheck.png" alt="未选中">
                </div>
                
            </template>
        </van-cell>
    </van-cell-group>
    <div class="flex service">
        <div @click="selectService">
            <img v-if="isAgree" src="@/assets/imgs/members/xz.png" alt="未选中">
            <img v-else src="@/assets/imgs/members/uncheck.png" alt="选中">
        </div>
        <span>我已阅读并同意 <a :href="proUrl">《会员服务开通协议》</a></span>
    </div>
    <div class="footer tc">
        <button @click="submit">支付</button>
    </div>
  </div>
</template>

<script>
import {priceYuan} from '@/libs/tool'
import {walletBalance,vipPay ,userAgreement} from '@/api/members'

export default {
  name: 'bug',
  data() { 
    return {
        detail:{ },
        isAgree:false,
        payWx:0,  //0未为微信，1为余额
        payWallet:0,  //0未为微信，1为余额

        totalPice:'19.9',  //价格
        myWallet:0,  //余额
        proUrl:null
    }
  },
  created(){
    //  this.detail =   JSON.parse(decodeURIComponent(this.$route.query.infos))
     this.detail = JSON.parse(localStorage.getItem('SETORDERINFOS'))
     this.totalPice = priceYuan(this.detail.discountsPrice)
    //  console.log(this.detail ,8888)
     this.getBalance()
     this.getuserAgreement()
  },

  methods:{

      priceYuan,
    //  获取钱包余额
      getBalance(){
          walletBalance().then(res=>{
              if(!res.code){
                  this.myWallet = res.data && res.data.amount
              }
          })
      },
      selectService(){
          this.isAgree = !this.isAgree
      },
      // 选择支付方式
      selectPay(val){
          this[val] = this[val] ? 0 : 1
      },
    // 获取协议
    getuserAgreement(){
        userAgreement({type:5}).then(res=>{
            if(!res.code){
               this.proUrl = res.data[0].url
            }
        })
    },
     // 确定支付
    submit(){
            this.$toast.loading({
                message: '正在跳转支付，请稍等...',
                forbidClick: true,
                duration:0
            });
          if(!this.isAgree) return this.$toast('请勾选查看会员开通服务！')
          if(!this.payWx && !this.payWallet) return this.$toast('请选择付款方式！')
            /**
             * 单个支付方式
             * lawsuitShare、微信直接 2 或者余额直接支付 3
             * 组合支付 4
             * lawsuitShare、先查看余额是否有钱
             * 2、金额是大于会员价格 大于的话，直接购买成功
             * 3、小于的话，先扣余额的所有金额，然后再调起微信支付
             * 
             */
            const priceDiff =  (Number(this.myWallet) - Number(this.totalPice)).toFixed(2) //余额和价格的差价
            let payType = (this.payWx && this.payWallet && priceDiff <= 0)  && 4 || 
                          (this.payWx && this.payWallet && priceDiff > 0)  && 3 ||
                          (!this.payWx && this.payWallet) && 3 ||
                          (this.payWx && !this.payWallet) && 2 || null  //购买方式

            if(payType === 3 && priceDiff < 0) return this.$toast('余额不足，请选择其他支付方式！')

            const prams = {
                vipId:this.detail.vipId,
                vipClassId:this.detail.id,
                payType,
                price:(this.totalPice *100)   //接受分
            }

            // 下订单
            vipPay(prams).then(res=>{
                if(!res.code){
                    const obj = JSON.parse(JSON.stringify(res.data))
                    const h5 = res.data.payResultMsg && JSON.parse(res.data.payResultMsg)
                    
                    // 余额和余额+微信混合支付，跳转
                    if(payType !== 2){
                        if(Number(this.myWallet) === 0 && payType === 4) return window.location.href=h5.h5_url
                        this.$router.push({name:'memberPassword' ,query:{infos:encodeURIComponent(JSON.stringify(obj))}})
                    }else{
                        // 微信支付                        
                        window.location.href=h5.h5_url
                    }

                    this.$toast.clear()
                }
            })

      },

  }
 }
</script>

<style lang="scss" scoped>
    .buy{
        height: 100vh;
        background: #F5F5F7;
        color: #46474B;  
    }
    .buy-top{
        background: #F5F5F7;
        padding: 22px 0px;
    }
    .member-cards {
      height: 130px;
      box-sizing: border-box;
      width: 90%;
      margin: auto;
      left: 0;
      right: 0;
      background-size: 100% 100% !important;
      padding: 16px;
      box-sizing: border-box;
      color: #526378;

      .cards-top {
        img {
          width: 36px;
          height: 36px;
          margin-right: 9px;
          vertical-align: top;
        }
        h3 {
          font-size: 18px;
          margin-bottom: 4px;
        }
      }
      .cards-bottom {
        bottom: 16px;
      }
    }

    .buy-member{
         .van-cell{
            color:#46474B!important ;
        }
        .members-price{
            color: #4A549E;
            font-size: 16px;
            font-weight: 600;
        }

        img{
            width: 18px;
            height: 18px;
            vertical-align: middle;
            margin-right: 5px;
        }

        label{
            color: #4A549E;
            font-weight: 600;
        }
    }
    h4{
        line-height: 40px;
        font-size: 13px;  
        padding: 0 16px;
        font-weight: normal;
    }
    .service{
        padding: 16px;
        img{
            width: 15px;
            height: 15px;
            vertical-align: middle;
            position: relative;
            top: 2px;
            margin-right: 5px;
        }
        a{
            color: #D4B37D;
        }
        
    }
    .footer {
        position: fixed;
        bottom: 20px;
        width: 100%;

        button {
            width: 90%;
            line-height: 40px;
            background: #4A549E;
            color: #ffffff;
            font-size: 15px;
            outline: none;
            border: none;
            border-radius: 44px;
        }
    }
</style>